module.exports = __webpack_public_path__ + "static/media/sbs_logo.9a483579.png";